define('flight-components/mixins/withGeoValidation',[], function() {

  var withGeoValidation = function withGeoValidation() {

    this.validateGeo = function() {
      var self = this;

      var geo = self.select('geoInputSelector').typeahead('val');

      // validate
      self.getJSON('/validategeo?geo=' + geo, function(response) {
        if (response.status === 'error') {
          self.showError();
        } else {
          self.trigger('dataGeoValidated', {
            geo: geo
          });
        }
      });
    }

    this.showError = function() {
      this.select('geoInputSelector').addClass('error');
      this.select('errorMsgSelector').show();
    }

    this.after('initialize', function() {

    });

  };

  return withGeoValidation;

});
